<template>
  <div>
  <!-- 保险中心-案件列表--案件详情 -->

    <el-dialog
      :visible.sync="show"
      width="80%"
      :close-on-click-modal="false"
      :before-close="closeDialog"
    >
      <div class="adminMessage">上报人信息</div>
      <el-form ref="form" :model="report_info" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名:">
              <el-input disabled v-model="report_info.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件号:">
              <el-input
                disabled
                v-model="report_info.id_card"
                maxlength="18"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话号:">
              <el-input disabled v-model="report_info.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="adminMessage">车主信息</div>

        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名:">
              <el-input disabled v-model="owners.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话:">
              <el-input disabled v-model="owners.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="">
              <el-image
                :preview-src-list="srcList"
                v-for="(val,index) in owners.img"
                :key="index+'1'"
                :label="val"
                :value="val"
                style="width: 100px;;height:100px"
                :src="val"
              ></el-image>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="adminMessage">现场照片</div>

        <el-row>
          <el-col :span="24">
            <el-form-item label="">
              <el-image
                :preview-src-list="srcList"
                v-for="(item,index) in accident_img_arr"
                :key="index + '2'"
                :label="item"
                :value="item"
                style="width: 100px;height:100px"
                :src="item"
              ></el-image>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="adminMessage">事故描述</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="">
              <span>{{ accident_desc }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="adminMessage">
          状态:
          <span style="margin-left: 10px; color: red">{{ status_des }}</span>
        </div>

        <el-form-item style="display: flex; justify-content: center">
          
          <el-button @click="show = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    
  </div>
</template>

<script>
var _this;


export default {

  props: {
    isShow: Boolean,
    // 接受父组件传值
    data: "",
  },
  //监听父组件传过来的值
  watch: {
    isShow(newData, oldData) {
      _this.show = true;

      _this.search_data.out_insure_no = _this.data.out_insure_no;
      _this.getInsuranceDetail();
    },
  },

  data() {
    return {
      srcList: [],
      status: "",
      status_des: "",
      accident_desc: "",
      imgs: [],
      accident_img_arr: [],

      show: false,

      report_info: {
        name: "",
        id_card: "",
        phone: "",
      },
      owners: {
        name: "",
        img: "",
        phone: "",
      },
      search_data: {
        out_insure_no: "",
      },
    };
  },
  created() {
    _this = this;
  },
  methods: {
    // 管理员详情
    getInsuranceDetail() {
      _this
        .$post("/Insurance/getInsuranceDetail", _this.search_data)
        .then((res) => {
          _this.srcList = [];
          console.log(res);
          _this.report_info.name = res.data.report_info.name;
          _this.report_info.id_card = res.data.report_info.id_card;
          _this.report_info.phone = res.data.report_info.phone;
          _this.owners.name = res.data.owners.name;
     
          _this.owners.img = res.data.owners.img;

          _this.owners.phone = res.data.owners.phone;
          _this.accident_img_arr = res.data.accident_img;
          for (let i = 0; i < _this.accident_img_arr.length; i++) {
            _this.srcList.push(_this.accident_img_arr[i]);
          }
          for (let j = 0; j < _this.owners.img.length; j++) {
            _this.srcList.push(_this.owners.img[j]);
          }
          console.log(_this.srcList, "====");

          _this.accident_desc = res.data.accident_desc;
          _this.status = res.data.status;
          _this.status_des = res.data.status_des;
        })
        .catch((err) => {});
    },


    closeDialog() {
      _this.srcList = [];

      _this.status = "";
      _this.status_des = "";
      _this.accident_desc = "";
      _this.imgs = [];
      _this.accident_img_arr = [];

      _this.show = false;

      _this.report_info = {
        name: "",
        id_card: "",
        phone: "",
      };
      _this.owners = {
        name: "",
        img: "",
        phone: "",
      };
      _this.search_data = {
        out_insure_no: "",
      };

      _this.show = false;
    },
  },
};
</script>
<style scoped>
.juese {
  width: 70%;
  margin-top: 5px;
}

.row-list {
  display: flex;

  flex-direction: row;

  align-items: center;

  justify-content: flex-start;

  flex-wrap: wrap;
}

.row-list .el-form-item {
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: flex-start;

  width: 50%;
}

.row-list .el-form-item .el-input {
  margin-left: 0;
}

.adminMessage {
  font-family: Microsoft YaHei;
  font-weight: 600;
  line-height: 21px;
  color: #222;
  margin-bottom: 20px;
  font-size: 18px;
}

.xiala {
  margin-left: 20px;
}
</style>